import { Component } from '@angular/core';

import {
  CheckboxComponent,
  ColorPickerComponent,
  CultureComponent,
  DatePickerComponent,
  FormLabelComponent,
  InputPlaceholderComponent,
  LabelComponent,
  SearchFieldComponent,
  SliderComponent,
  TextBoxComponent,
  TextareaComponent,
  TimePickerComponent,
  ToggleComponent,
} from '@camelot/form-input';
import {
  InputCheckBox,
  InputColorPicker,
  InputCulture,
  InputDatePicker,
  InputLabel,
  InputSlider,
  InputTextBox,
  InputTextarea,
  InputTimePicker,
} from '@camelot/form-model';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        CheckboxComponent,
        ColorPickerComponent,
        CultureComponent,
        DatePickerComponent,
        FormLabelComponent,
        InputPlaceholderComponent,
        LabelComponent,
        SearchFieldComponent,
        SliderComponent,
        TestIdDirective,
        TextBoxComponent,
        TextareaComponent,
        TimePickerComponent,
        ToggleComponent,
    ],
    template: `
    <cam-input-textbox camTestId="cam-input-textbox" [input]="this.textbox" [standalone]="true" />
    <cam-input-textarea camTestId="cam-input-textarea" [input]="this.textarea" [standalone]="true" />
    <cam-input-checkbox camTestId="cam-input-checkbox" [input]="this.checkbox" [standalone]="true" />
    <cam-input-toggle camTestId="cam-input-toggle" [input]="this.toggle" [standalone]="true" />
    <cam-input-slider camTestId="cam-input-slider" [input]="this.slider" [standalone]="true" />
    <cam-input-label camTestId="cam-input-label" [input]="this.label" [standalone]="true" />
    <cam-input-culture camTestId="cam-input-culture" [input]="this.culture" [standalone]="true" />
    <cam-input-color-picker camTestId="cam-input-color-picker" [input]="this.colorPicker" [standalone]="true" />
    <cam-input-date-picker camTestId="cam-input-date-picker" [input]="this.datePicker" [standalone]="true" />
    <cam-input-time-picker camTestId="cam-input-time-picker" [input]="this.timePicker" [standalone]="true" />
    <cam-search-field camTestId="cam-search-field" [input]="this.searchField" />
    <cam-input-placeholder camTestId="cam-input-placeholder" />
    <cam-form-label camTestId="cam-form-label" [input]="this.formLabel" />
  `
})
export class FormInputsBasicCase {
  public checkbox = new InputCheckBox({ key: 'checkbox', label: 'Checkbox' });
  public colorPicker = new InputColorPicker({ key: 'color', label: 'Color' });
  public culture = new InputCulture({ key: 'culture', label: 'Culture' });
  public datePicker = new InputDatePicker({ key: 'date', label: 'Date' });
  public formLabel = { label: 'Form label', validators: [] };
  public label = new InputLabel({ key: 'label', label: 'A label' });
  public searchField = new InputTextBox({ key: 'search', label: 'Search' });
  public slider = new InputSlider({ key: 'slider', label: 'Slider' });
  public textarea = new InputTextarea({ key: 'textarea', label: 'Textarea' });
  public textbox = new InputTextBox({ key: 'textbox', label: 'Textbox' });
  public timePicker = new InputTimePicker({ key: 'time', label: 'Time' });
  public toggle = new InputCheckBox({ key: 'toggle', label: 'Toggle', toggle: true });
}
